import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Dashboard.module.scss';
import Container from '../Container/Container';
import cn from 'classnames';
const Dashboard = ({ children, className, container }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.element, className, 'd-flex justify-content-center') }, { children: _jsx(Container, { children: children }) })));
};
export default Dashboard;
